import moment from 'moment';

export function isMomentPropType(props, propName, component) {
  if (props[propName]) {
    return moment.isMoment(props[propName]) ? null : new Error(`${propName} in ${component} has to be of type Moment`);
  }
  return null;
}

export function isMomentArray(propValue, key, component, location, propFullName) {
  if (propValue[key]) {
    return moment.isMoment(propValue[key]) ? null : new Error(`${propFullName} in ${component} has to be of type Moment`);
  }
  return null;
}
